import axios from 'axios';


// 요청 인터셉터 추가하기  -> 서버에 요청하기전 인터셉터
axios.interceptors.request.use(
    (config) => {
        //console.log("=================request ==============================");
        // 파라미터에 사용자 Timezone 셋팅하여 전송
        config.params = { 
            ...config.params, 
            timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
        };
        //console.log(config.params);
        //console.log("요청 url", config.url)

        //console.log("=================request ==============================");
        // 파라미터에 사용자 Timezone 셋팅하여 전송
        config.params = {
            ...config.params,
            timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
        };


        let browserLang = (navigator.language || navigator.userLanguage || navigator.systemLanguage || 'en').toLowerCase();
        // 브라우저 언어에서 언어코드만 추출 (예: en-US → en, cnr → cnr)
        let langCode = browserLang.split('-')[0];
        const supportedLocales = ['en','ko','fr','es','de','it','pt','he','pl','nl','cs',
            'el','no','da','lv','ro','lb','lt','mk','cnr','mt','bs','bg','sr',
            'fi','sv','sk','sl','ar','ga','sq','et','hr','tr','hu','is','uk'];
        // 지원하지 않는 언어일 경우 영문으로 강제 설정
        if (!supportedLocales.includes(langCode)) {
            config.headers['Accept-Language'] = 'en-US';
        }

        return config;
    },
    (error) => {
        console.log("=================reuest error =======================")
        return Promise.reject("request error :", error);
    }
);

export default axios;